import { Box, Button, Collapse, Dialog, DialogContent, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";

import { StyledRating } from "../Question/StyledRating";

type Props = {
    open: boolean;
    onClose: () => void;
    onSubmit: (rating: number, comment: string | null) => void;
};

export const FeedbackModal: React.FC<Props> = ({ open, onClose, onSubmit }) => {
    const [rating, setRating] = React.useState<number>(0);
    const [comment, setComment] = React.useState("");
    const inputRef = React.useRef<HTMLTextAreaElement>(null);

    const handleSubmit = () => {
        onSubmit(rating, comment || null);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogContent sx={{ p: 4 }}>
                <Typography variant="textLg" fontWeight={600} display="block" sx={{ mb: 0.5 }}>
                    <FormattedMessage defaultMessage="How was this experience?" />
                </Typography>
                <Typography variant="textSm" color="textTextHelper" display="block" sx={{ mb: 3 }}>
                    <FormattedMessage defaultMessage="Your feedback helps us improve the information request process." />
                </Typography>

                <StyledRating showLabels value={rating} onChange={(_, v) => setRating(v as number)} />

                <Collapse in={rating > 0} onEntered={() => inputRef.current?.focus()}>
                    <Stack spacing={1.5} sx={{ mt: 3 }}>
                        <Typography variant="textSm" color="textTextHelper">
                            <FormattedMessage defaultMessage="Tell us more (optional)" />
                        </Typography>
                        <TextField
                            inputRef={inputRef}
                            multiline
                            minRows={3}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            fullWidth
                        />
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button variant="contained" onClick={handleSubmit}>
                                <FormattedMessage defaultMessage="Submit" />
                            </Button>
                        </Box>
                    </Stack>
                </Collapse>
            </DialogContent>
        </Dialog>
    );
};

export default FeedbackModal;
